import dynamic from 'next/dynamic';
import { DynamicSlotComponents } from '../types';

const ProductGridDesktopSlot = dynamic(() =>
  import('./product-grid').then((f) => f.ProductGridSlot.desktop),
);

const ProductGridMobileSlot = dynamic(() =>
  import('./product-grid').then((f) => f.ProductGridSlot.mobile),
);

const ProductCarouselSlot = dynamic(() =>
  import('./ProductCarousel').then((f) => f.LazyProductCarouselSlot),
);

const HamperCarouselSlot = dynamic(() =>
  import('./HamperCarousel/HamperCarousel').then(
    (f) => f.LazyHamperCarouselSlot,
  ),
);

const NewLayoutProductCarouselSlot = dynamic(() =>
  import('./ProductCarousel').then((f) => f.LazyNewLayoutProductCarouselSlot),
);

const PendingPaymentSlot = dynamic(() =>
  import('./PendingPayment').then((f) => f.PendingPaymentSlot),
);
const RecentProductMobileSlot = dynamic(() =>
  import('./RecentProduct').then((f) => f.LazyRecentProductMobileSlot),
);
const RecentProductDesktopSlot = dynamic(() =>
  import('./RecentProduct').then((f) => f.LazyRecentProductDesktopSlot),
);
const RecentSearchSlot = dynamic(() =>
  import('./RecentSearch').then((f) => f.LazyRecentSearchSlot),
);
const HeaderSearchDesktopSlot = dynamic(() =>
  import('./header-search').then((f) => f.HeaderSearchSlot.desktop),
);
const HeaderSearchMobileSlot = dynamic(() =>
  import('./header-search').then((f) => f.HeaderSearchSlot.mobile),
);
const HeaderRightItemDesktopSlot = dynamic(() =>
  import('./header-right-item').then((f) => f.HeaderRightItemSlot.desktop),
);
const HeaderRightItemMobileSlot = dynamic(() =>
  import('./header-right-item').then((f) => f.HeaderRightItemSlot.mobile),
);
const SearchBarRightItemsMobile = dynamic(() =>
  import('./header-search').then((f) => f.SearchBarRightItemsMobile),
);
const LocationPickerHeaderMobile = dynamic(() =>
  import('./location-picker-mobile').then((f) => f.LocationPickerHeaderMobile),
);
const BuildPCPickerDesktopSlot = dynamic(() =>
  import('./BuildPC').then((f) => f.BuildPCPickerDesktopSlot),
);
const BuildPCPickerMobileSlot = dynamic(() =>
  import('./BuildPC').then((f) => f.BuildPCPickerMobileSlot),
);

const CustomHamperDesktopSlot = dynamic(() =>
  import('./CustomHamper').then((f) => f.CustomHamperDesktopSlot),
);

const CustomHamperMobileSlot = dynamic(() =>
  import('./CustomHamper').then((f) => f.CustomHamperMobileSlot),
);

const LeftBannerProductMobileSlot = dynamic(() =>
  import('./left-banner-product').then(
    (f) => f.LazyLeftBannerProductMobileSlot,
  ),
);

const VideoPreviewCarouselSlot = dynamic(() =>
  import('./VideoPreviewList').then((f) => f.LazyVideoPreviewCarousel),
);

const RecommendProductModalSlot = dynamic(() =>
  import('./RecommendProductModal').then((f) => f.RecommendProductModalSlot),
);

export const mappingDynamicDesktopSlots: DynamicSlotComponents = {
  product_grid_desktop: ProductGridDesktopSlot,
  product_carousel_desktop: ProductCarouselSlot,
  hamper_carousel_desktop: HamperCarouselSlot,
  recent_product: RecentProductDesktopSlot,
  header_search_desktop: HeaderSearchDesktopSlot,
  header_right_items_desktop: HeaderRightItemDesktopSlot,
  build_pc: BuildPCPickerDesktopSlot,
  new_layout_product_carousel_desktop: NewLayoutProductCarouselSlot,
  video_preview_carouse: VideoPreviewCarouselSlot,
  custom_hamper: CustomHamperDesktopSlot,
  modal_recommend_product: RecommendProductModalSlot,
};

export const mappingDynamicMobileSlots: DynamicSlotComponents = {
  product_grid_mobile: ProductGridMobileSlot,
  product_carousel_mobile: ProductCarouselSlot,
  hamper_carousel_mobile: HamperCarouselSlot,
  pending_payment: PendingPaymentSlot,
  recent_product: RecentProductMobileSlot,
  recent_search: RecentSearchSlot,
  header_search_mobile: HeaderSearchMobileSlot,
  header_right_items_mobile: HeaderRightItemMobileSlot,
  search_bar_right_items_mobile: SearchBarRightItemsMobile,
  build_pc: BuildPCPickerMobileSlot,
  left_banner_product_mobile: LeftBannerProductMobileSlot,
  location_picker_header_mobile: LocationPickerHeaderMobile,
  new_layout_product_carousel_mobile: NewLayoutProductCarouselSlot,
  video_preview_carouse: VideoPreviewCarouselSlot,
  custom_hamper: CustomHamperMobileSlot,
  modal_recommend_product: RecommendProductModalSlot,
};
